"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-react";
function WaitlistForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-[#09080A]/80 border border-[#C48A3A]/30 rounded-lg text-center backdrop-blur-sm">
        <h3 className="text-2xl font-serif font-bold text-[#C48A3A] mb-2">You’re on the list!</h3>
        <p className="text-[#C9B8F5] mb-6">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-[#C48A3A] text-[#C48A3A] hover:bg-[#C48A3A]/10 hover:text-[#C48A3A]">
          Submit Another
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6 text-left">
      <div className="flex flex-col md:flex-row items-start gap-4">
        <div className="flex-1 w-full">
          <FormField control={control} name="email" rules={{
          required: "Email Address is required",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-[#F5F0FF] sr-only">Email Address</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="Enter your email address" className="bg-[#09080A]/80 border-[#C48A3A] text-[#F5F0FF] placeholder:text-[#F5F0FF]/40 focus-visible:ring-[#C48A3A]/50 h-12" {...field} />
                </FormControl>
                <FormMessage className="text-red-400" />
              </FormItem>} />
        </div>

        <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto px-8 bg-[#C48A3A] text-[#09080A] hover:bg-[#C48A3A]/90 font-bold text-lg h-12 rounded-md transition-all shrink-0">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Processing...
            </> : 'Join Waitlist'}
        </Button>
      </div>

      {submitError && <div className="p-3 bg-red-950/50 border border-red-900 rounded-md">
          <p className="text-red-400 text-sm text-center">{submitError}</p>
        </div>}

      <p className="text-center text-[12px] text-[#C9B8F5]/60">
        No spam. Just soil science. Unsubscribe anytime.
      </p>
    </Form>;
}
export default function JoinTheWaitlist() {
  return <section id="be-the-first-to-dig-in" className="relative py-24 lg:py-32 bg-[#09080A] overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_-20%,#1A0B2E_0%,transparent_70%)] pointer-events-none" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-[#F5F0FF] mb-4 tracking-tight">
            Be the first to dig in.
          </h2>
          <p className="text-[#C9B8F5] text-lg mb-10 max-w-lg mx-auto">
            Join our exclusive waitlist to receive early access to the field kit, limited edition soil profiles, and development updates.
          </p>
          
          <div className="bg-[#09080A]/40 p-6 md:p-10 rounded-xl border border-[#C48A3A]/20 backdrop-blur-md shadow-2xl shadow-[#1A0B2E]/50">
            <FormProvider formId="waitlist_form_terrigma" sectionName="Join The Waitlist" defaultValues={{
            email: ""
          }} validationRules={{
            email: {
              required: true,
              pattern: "email"
            }
          }} submitText="Join Waitlist" successMessage="You have successfully joined the Terrigma waitlist. Prepare for excavation.">
              <WaitlistForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}